export { FaqPage as default } from '@/components/pages/Ir/faq'
